export const firebaseConfig = {
    apiKey: "AIzaSyAf0r5wRSA6H-lknmAqoJ1-jMNF6chH7yA",
    authDomain: "resume-website-10300.firebaseapp.com",
    projectId: "resume-website-10300",
    storageBucket: "resume-website-10300.firebasestorage.app",
    messagingSenderId: "839080761770",
    appId: "1:839080761770:web:01d5084ed506f66036b3d3",
    measurementId: "G-CSDX8ZRT28"
  };
  